<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        Crear puesto de trabajo
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <form [formGroup]="jobForm">
        <div class="form-group">
            <label for="jobName" class="form-label">Nombre</label>
            <input type="text" class="form-control" id="jobName" formControlName="name">
        </div>
        <p *ngIf="jobForm.controls['name'].touched && jobForm.controls['name'].invalid" class="text-danger">
            Este campo es requerido</p>
    </form>
    <div class="form-group">
        <label for="typeahead-supervisor">Supervisor</label>
        <input id="typeahead-supervisor" type="text" class="form-control" [class.is-invalid]="searchFailed"
            [(ngModel)]="supervisor" [ngbTypeahead]="searchSupervisor" placeholder="Nombre supervisor"
            [inputFormatter]="formatter" [resultFormatter]="formatter"/>
    </div>
    <div class="form-group">
        <label for="typeahead-auditor">Auditor</label>
        <input id="typeahead-auditor" type="text" class="form-control" [class.is-invalid]="searchFailed"
            [(ngModel)]="auditor" [ngbTypeahead]="searchAuditor" placeholder="Nombre auditor"
            [inputFormatter]="formatter" [resultFormatter]="formatter"/>
    </div>
    <ul class="list-group">
        <li class="list-group-item flex-column align-items-start" *ngIf="supervisor && supervisor.id">
            <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-3">{{supervisor.name + " " + supervisor.lastName}}</h5>
                <small class="badge">
                    <span class="material-icons">
                        supervised_user_circle
                    </span>
                </small>
            </div>
            <p class="mb-2 text-break">{{supervisor.phone}}</p>
            <small>{{supervisor.email}}</small>
        </li>
        <li class="list-group-item flex-column align-items-start" *ngIf="auditor && auditor.id">
            <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-3">{{auditor.name + " " + auditor.lastName}}</h5>
                <small class="badge">
                    <span class="material-icons">
                        gavel
                    </span>
                </small>
            </div>
            <p class="mb-2 text-break">{{auditor.phone}}</p>
            <small>{{auditor.email}}</small>
        </li>
    </ul>
    <div class="btn-group">
        <input class="form-control" type="file" id="formFile" (change)="uploadFile($event.target)"
            accept="application/pdf" style="display: none;" #file>
        <button class="btn btn-sm btn-icon btn-success" (click)="file.click()" ngbTooltip="Subir PDF"
            [disabled]="isUploadingFile">
            <span class="material-icons">
                upload
            </span>
        </button>
        <button class="btn btn-sm btn-icon btn-info" (click)="downloadFile()" ngbTooltip="Descargar PDF"
            *ngIf="jobForm.value.url">
            <span class="material-icons">
                download
            </span>
        </button>
    </div>
    <div class="progress" *ngIf="isUploadingFile">
        <div class="progress-bar bg-success" role="progressbar" [ngStyle]="{'width': currentPercentage + '%'}"
            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
</div>
<div class="modal-footer">
    <div class="btn-group w-100" role="group">
        <button type="button" class="btn btn-secondary" (click)="ngbActiveModal.close()" [disabled]="isSaving">
            <span>Cancelar</span>
        </button>
        <button type="button" class="btn btn-success"
            [disabled]="jobForm.invalid || isSaving || !supervisor || !auditor" (click)="save()">
            <span>Guardar</span>
            <div class="spinner-border" role="status" *ngIf="isSaving">
                <span class="visually-hidden"></span>
            </div>
        </button>
    </div>
</div>